export default {
    profile:        [],
    uploadProgress: 0,
    is_profile_complete: false,
}